import { DatePicker } from 'antd';
import styled from 'styled-components';

export const AStyledDatePicker = styled(DatePicker)<{ condensed?: boolean; lock?: boolean }>`
    height: 32px;
    width: 100%;
    ${({ lock, condensed }) => lock && `border-radius: ${condensed ? '4px' : '2px'};`}
    border: ${({ condensed }) => (condensed ? '1px solid #cecece' : 'hsv(0, 0, 85%)')};
    ${({ lock }) =>
        lock &&
        'border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important; border-bottom-left-radius: 4px; border-top-left-radius: 4px;'}
`;

export const DatePickerDiv = styled.div`
    width: 100%;
    display: inline-flex;
`;
